import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "formulario",
  class: "py-12"
}
const _hoisted_2 = { class: "container mx-auto px-4 max-w-6xl" }
const _hoisted_3 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_4 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_5 = { class: "text-sm text-red-500 p-error" }
const _hoisted_6 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_7 = { class: "text-sm text-red-500 p-error" }
const _hoisted_8 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_9 = { class: "text-sm text-red-500 p-error" }
const _hoisted_10 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_11 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_12 = { class: "text-sm text-red-500 p-error" }
const _hoisted_13 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_14 = { class: "text-sm text-red-500 p-error" }
const _hoisted_15 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_16 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_17 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_18 = ["src"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "flex items-center" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "text-sm text-red-500 p-error" }
const _hoisted_23 = {
  key: 0,
  class: "w-full px-2 md:w-4/12"
}
const _hoisted_24 = { class: "text-sm text-red-500 p-error" }
const _hoisted_25 = {
  key: 1,
  class: "w-full px-2 md:w-4/12"
}
const _hoisted_26 = { class: "text-sm text-red-500 p-error" }
const _hoisted_27 = {
  key: 2,
  class: "w-full px-2 md:w-4/12"
}
const _hoisted_28 = { class: "text-sm text-red-500 p-error" }
const _hoisted_29 = {
  key: 3,
  class: "w-full px-2 md:w-4/12"
}
const _hoisted_30 = { class: "text-sm text-red-500 p-error" }
const _hoisted_31 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_32 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_33 = { class: "text-sm text-red-500 p-error" }
const _hoisted_34 = { class: "space-y-4 mt-6 p-4 border border-blue-200 bg-blue-50/20 rounded-lg" }
const _hoisted_35 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0" }
const _hoisted_36 = { class: "w-full px-2 md:w-12/12" }
const _hoisted_37 = { class: "text-sm text-red-500 p-error" }
const _hoisted_38 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_39 = { class: "w-full px-2 md:w-12/12" }
const _hoisted_40 = { class: "text-sm text-red-500 p-error" }
const _hoisted_41 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_42 = { class: "text-sm text-red-500 p-error" }
const _hoisted_43 = {
  key: 0,
  class: "w-full px-2 md:w-6/12"
}
const _hoisted_44 = { class: "text-sm text-red-500 p-error" }
const _hoisted_45 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_46 = { class: "text-sm text-red-500 p-error" }
const _hoisted_47 = {
  key: 0,
  class: "w-full px-2 md:w-6/12"
}
const _hoisted_48 = { class: "text-sm text-red-500 p-error" }
const _hoisted_49 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_50 = { class: "w-full px-2 md:w-12/12" }
const _hoisted_51 = { class: "text-sm text-red-500 p-error" }
const _hoisted_52 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_53 = { class: "text-sm text-red-500 p-error" }
const _hoisted_54 = {
  key: 0,
  class: "w-full px-2 md:w-6/12"
}
const _hoisted_55 = { class: "text-sm text-red-500 p-error" }
const _hoisted_56 = { key: 0 }
const _hoisted_57 = { class: "p-4 bg-gray-50 border rounded-lg" }
const _hoisted_58 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-4" }
const _hoisted_59 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_60 = { class: "text-sm text-red-500 p-error" }
const _hoisted_61 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_62 = { class: "text-sm text-red-500 p-error" }
const _hoisted_63 = { class: "space-y-6 bg-gray-50 p-6 rounded-lg border" }
const _hoisted_64 = { class: "flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 pb-4 border-b border-gray-200" }
const _hoisted_65 = { class: "flex items-start gap-3 cursor-pointer" }
const _hoisted_66 = { class: "text-sm text-red-500 p-error block mt-1" }
const _hoisted_67 = { class: "pt-4 border-t border-gray-200" }
const _hoisted_68 = { class: "flex items-start gap-3 cursor-pointer" }
const _hoisted_69 = { class: "text-sm text-red-500 p-error block mt-1" }
const _hoisted_70 = { class: "pt-4 border-t border-gray-200" }
const _hoisted_71 = { class: "flex items-start gap-3 cursor-pointer" }
const _hoisted_72 = { class: "flex items-start gap-3 cursor-pointer" }
const _hoisted_73 = { class: "text-sm text-red-500 p-error block mt-1" }
const _hoisted_74 = { class: "flex flex-wrap py-2 mt-3" }
const _hoisted_75 = ["disabled"]
const _hoisted_76 = { class: "pi pi-spin pi-spinner mr-2" }
const _hoisted_77 = { class: "pi pi-check mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderSection = _resolveComponent("HeaderSection")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Select = _resolveComponent("Select")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_Form = _resolveComponent("Form")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HeaderSection),
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_Form, {
        onSubmit: _ctx.onSubmit,
        "validation-schema": _ctx.schema,
        class: "space-y-4 text-gray-700",
        onInvalidSubmit: _ctx.onInvalidSubmit
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _cache[64] || (_cache[64] = _createElementVNode("h1", { class: "font-bold text-gray-800 mb-0 text-3xl text-center pt-5 font-antonio-bold" }, " ¡Bienvenidos/as a Córdoba Tech Week 2026! ", -1)),
            _cache[65] || (_cache[65] = _createElementVNode("h1", { class: "text-gray-800 mb-4 text-2xl text-center pt-2 pb-5 font-antonio-bold" }, " Por favor completá el formulario de inscripción con todos tus datos ", -1)),
            _cache[66] || (_cache[66] = _createElementVNode("div", { class: "flex flex-wrap space-y-4 md:space-y-0 border border-gray-500 rounded-md shadow-lg mb-6" }, [
              _createElementVNode("div", { class: "w-full text-gray-800 text-2xl text-center font-antonio-bold py-4" }, " Datos personales ")
            ], -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[30] || (_cache[30] = _createElementVNode("label", { class: "block mb-1 font-semibold" }, "Nombre *", -1)),
                _createVNode(_component_Field, {
                  name: "nombre",
                  modelValue: _ctx.formData.nombre,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.nombre) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Nombre",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_5, [
                      _createVNode(_component_ErrorMessage, { name: "nombre" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[31] || (_cache[31] = _createElementVNode("label", { class: "block mb-1 font-semibold" }, "Apellido *", -1)),
                _createVNode(_component_Field, {
                  name: "apellido",
                  modelValue: _ctx.formData.apellido,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.apellido) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Apellido",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_7, [
                      _createVNode(_component_ErrorMessage, { name: "apellido" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[32] || (_cache[32] = _createElementVNode("label", { class: "block mb-1 font-semibold" }, "DNI *", -1)),
                _createVNode(_component_Field, {
                  name: "dni",
                  modelValue: _ctx.formData.dni,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.dni) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Número de DNI",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_9, [
                      _createVNode(_component_ErrorMessage, { name: "dni" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[33] || (_cache[33] = _createElementVNode("label", { class: "block mb-1 font-semibold" }, "Correo electrónico *", -1)),
                _createVNode(_component_Field, {
                  name: "mail",
                  modelValue: _ctx.formData.mail,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.mail) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "email",
                      placeholder: "correo@ejemplo.com",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_12, [
                      _createVNode(_component_ErrorMessage, { name: "mail" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _cache[34] || (_cache[34] = _createElementVNode("label", { class: "block mb-1 font-semibold" }, "Teléfono celular (con código de área) *", -1)),
                _createVNode(_component_Field, {
                  name: "telefonoCelular",
                  modelValue: _ctx.formData.telefonoCelular,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.telefonoCelular) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Número (ej: 3511234567)",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_14, [
                      _createVNode(_component_ErrorMessage, { name: "telefonoCelular" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _cache[35] || (_cache[35] = _createElementVNode("label", { class: "block mb-1 font-semibold" }, "Desde dónde nos visitás (País) *", -1)),
                _createVNode(_component_Field, {
                  name: "paisDomicilio",
                  modelValue: _ctx.formData.paisDomicilio,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.paisDomicilio) = $event))
                }, {
                  default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                    _createVNode(_component_Select, {
                      filter: "",
                      onBlur: handleBlur,
                      "onUpdate:modelValue": handleChange,
                      "model-value": value,
                      class: _normalizeClass([{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }, "input-base"]),
                      placeholder: "País",
                      options: _ctx.paises,
                      optionLabel: "descripcion"
                    }, {
                      value: _withCtx((slotProps) => [
                        (slotProps.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              (slotProps.value.isocode)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: _ctx.getFlagUrl(slotProps.value.isocode),
                                    class: "mr-2 border border-gray-200",
                                    style: {"width":"20px","height":"auto"}
                                  }, null, 8, _hoisted_18))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", null, _toDisplayString(slotProps.value.descripcion), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(slotProps.placeholder), 1))
                      ]),
                      option: _withCtx((slotProps) => [
                        _createElementVNode("div", _hoisted_20, [
                          (slotProps.option.isocode)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _ctx.getFlagUrl(slotProps.option.isocode),
                                class: "mr-2 border border-gray-200",
                                style: {"width":"20px","height":"auto"}
                              }, null, 8, _hoisted_21))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", null, _toDisplayString(slotProps.option.descripcion), 1)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["onBlur", "onUpdate:modelValue", "model-value", "class", "options"]),
                    _createElementVNode("span", _hoisted_22, [
                      _createVNode(_component_ErrorMessage, { name: "paisDomicilio" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              (_ctx.formData.paisDomicilio?.id === '+54')
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _cache[36] || (_cache[36] = _createElementVNode("label", { class: "block mb-1 font-semibold" }, "Provincia *", -1)),
                    _createVNode(_component_Field, {
                      name: "provincia",
                      modelValue: _ctx.formData.provincia,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.provincia) = $event))
                    }, {
                      default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                        _createVNode(_component_Select, {
                          onBlur: handleBlur,
                          "onUpdate:modelValue": handleChange,
                          "model-value": value,
                          placeholder: "Seleccione la provincia",
                          options: _ctx.provincias,
                          optionLabel: "descripcion",
                          class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }])
                        }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                        _createElementVNode("span", _hoisted_24, [
                          _createVNode(_component_ErrorMessage, { name: "provincia" })
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.formData.paisDomicilio?.id === '+54')
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _cache[37] || (_cache[37] = _createElementVNode("label", { class: "block mb-1 font-semibold" }, "Ciudad *", -1)),
                    _createVNode(_component_Field, {
                      name: "localidad",
                      modelValue: _ctx.formData.localidad,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.localidad) = $event))
                    }, {
                      default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                        _createVNode(_component_Select, {
                          onBlur: handleBlur,
                          filter: "",
                          "onUpdate:modelValue": handleChange,
                          "model-value": value,
                          placeholder: "Seleccione la ciudad",
                          class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }]),
                          options: _ctx.localidades,
                          optionLabel: "descripcion"
                        }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                        _createElementVNode("span", _hoisted_26, [
                          _createVNode(_component_ErrorMessage, { name: "localidad" })
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.formData.paisDomicilio?.id !== '+54')
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _cache[38] || (_cache[38] = _createElementVNode("label", { class: "block mb-1 font-semibold" }, "Provincia / Estado *", -1)),
                    _createVNode(_component_Field, {
                      name: "provinciaEstado",
                      modelValue: _ctx.formData.provinciaEstado,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.provinciaEstado) = $event))
                    }, {
                      default: _withCtx(({ field, errors }) => [
                        _createVNode(_component_InputText, _mergeProps(field, {
                          type: "text",
                          placeholder: "Ingrese su provincia o estado",
                          class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                        }), null, 16, ["class"]),
                        _createElementVNode("span", _hoisted_28, [
                          _createVNode(_component_ErrorMessage, { name: "provinciaEstado" })
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.formData.paisDomicilio?.id !== '+54')
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _cache[39] || (_cache[39] = _createElementVNode("label", { class: "block mb-1 font-semibold" }, "Ciudad *", -1)),
                    _createVNode(_component_Field, {
                      name: "localidadCiudad",
                      modelValue: _ctx.formData.localidadCiudad,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.localidadCiudad) = $event))
                    }, {
                      default: _withCtx(({ field, errors }) => [
                        _createVNode(_component_InputText, _mergeProps(field, {
                          type: "text",
                          placeholder: "Ingrese su ciudad",
                          class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                        }), null, 16, ["class"]),
                        _createElementVNode("span", _hoisted_30, [
                          _createVNode(_component_ErrorMessage, { name: "localidadCiudad" })
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _cache[40] || (_cache[40] = _createElementVNode("label", { class: "block mb-1 font-semibold" }, "Edad *", -1)),
                _createVNode(_component_Field, {
                  name: "rangoEtario",
                  modelValue: _ctx.formData.rangoEtario,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.rangoEtario) = $event))
                }, {
                  default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                    _createVNode(_component_Select, {
                      onBlur: handleBlur,
                      "onUpdate:modelValue": handleChange,
                      "model-value": value,
                      placeholder: "Seleccione su rango de edad",
                      class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }]),
                      options: _ctx.rangosEtarios,
                      optionLabel: "descripcion"
                    }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                    _createElementVNode("span", _hoisted_33, [
                      _createVNode(_component_ErrorMessage, { name: "rangoEtario" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _cache[67] || (_cache[67] = _createElementVNode("div", { class: "flex flex-wrap space-y-4 md:space-y-0 border border-gray-500 rounded-md shadow-lg mt-11 mb-6" }, [
              _createElementVNode("div", { class: "w-full text-gray-800 text-2xl text-center font-antonio-bold py-4" }, " Información Institucional y Profesional ")
            ], -1)),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _cache[41] || (_cache[41] = _createElementVNode("label", { class: "block mb-1 font-semibold" }, "Nombre de la Institución a la que pertenece (Nombre de la Empresa, Organización, Universidad o Institución a la que pertenece) *", -1)),
                  _createVNode(_component_Field, {
                    name: "empresa",
                    modelValue: _ctx.formData.empresa,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.empresa) = $event))
                  }, {
                    default: _withCtx(({ field, errors }) => [
                      _createVNode(_component_InputText, _mergeProps(field, {
                        type: "text",
                        placeholder: "Nombre de la Empresa, Organización, Universidad o Institución a la que pertenece",
                        class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                      }), null, 16, ["class"]),
                      _createElementVNode("span", _hoisted_37, [
                        _createVNode(_component_ErrorMessage, { name: "empresa" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _cache[42] || (_cache[42] = _createElementVNode("label", { class: "block mb-1 font-semibold" }, "Profesión o Carrera en curso *", -1)),
                  _createVNode(_component_Field, {
                    name: "profesionCarrera",
                    modelValue: _ctx.formData.profesionCarrera,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.profesionCarrera) = $event))
                  }, {
                    default: _withCtx(({ field, errors }) => [
                      _createVNode(_component_InputText, _mergeProps(field, {
                        type: "text",
                        placeholder: "Profesión o carrera en curso",
                        class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                      }), null, 16, ["class"]),
                      _createElementVNode("span", _hoisted_40, [
                        _createVNode(_component_ErrorMessage, { name: "profesionCarrera" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", {
                  class: _normalizeClass(["w-full px-2", _ctx.formData.nivelResponsabilidad?.id === 'Otro (especificar)' ? 'md:w-6/12' : 'md:w-12/12'])
                }, [
                  _cache[43] || (_cache[43] = _createElementVNode("label", { class: "block mb-1 font-semibold" }, "¿Cuál es tu nivel de responsabilidad? *", -1)),
                  _createVNode(_component_Field, {
                    name: "nivelResponsabilidad",
                    modelValue: _ctx.formData.nivelResponsabilidad,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.nivelResponsabilidad) = $event))
                  }, {
                    default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                      _createVNode(_component_Select, {
                        onBlur: handleBlur,
                        "onUpdate:modelValue": handleChange,
                        "model-value": value,
                        placeholder: "Seleccione su nivel de responsabilidad",
                        class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }]),
                        options: _ctx.nivelesResponsabilidad,
                        optionLabel: "descripcion"
                      }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                      _createElementVNode("span", _hoisted_42, [
                        _createVNode(_component_ErrorMessage, { name: "nivelResponsabilidad" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ], 2),
                (_ctx.formData.nivelResponsabilidad?.id === 'Otro (especificar)')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                      _cache[44] || (_cache[44] = _createElementVNode("label", { class: "block mb-1 font-semibold" }, "Especificar nivel de responsabilidad *", -1)),
                      _createVNode(_component_Field, {
                        name: "nivelResponsabilidadOtro",
                        modelValue: _ctx.formData.nivelResponsabilidadOtro,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.nivelResponsabilidadOtro) = $event))
                      }, {
                        default: _withCtx(({ field, errors }) => [
                          _createVNode(_component_InputText, _mergeProps(field, {
                            type: "text",
                            placeholder: "Especifique su nivel de responsabilidad",
                            class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                          }), null, 16, ["class"]),
                          _createElementVNode("span", _hoisted_44, [
                            _createVNode(_component_ErrorMessage, { name: "nivelResponsabilidadOtro" })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", {
                  class: _normalizeClass(["w-full px-2", _ctx.formData.areaSector?.id === 'Otro (especificar)' ? 'md:w-6/12' : 'md:w-12/12'])
                }, [
                  _cache[45] || (_cache[45] = _createElementVNode("label", { class: "block mb-1 font-semibold" }, "Área o sector principal *", -1)),
                  _createVNode(_component_Field, {
                    name: "areaSector",
                    modelValue: _ctx.formData.areaSector,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.areaSector) = $event))
                  }, {
                    default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                      _createVNode(_component_Select, {
                        onBlur: handleBlur,
                        "onUpdate:modelValue": handleChange,
                        "model-value": value,
                        placeholder: "Seleccione el área o sector principal",
                        class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }]),
                        options: _ctx.areasSector,
                        optionLabel: "descripcion"
                      }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                      _createElementVNode("span", _hoisted_46, [
                        _createVNode(_component_ErrorMessage, { name: "areaSector" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ], 2),
                (_ctx.formData.areaSector?.id === 'Otro (especificar)')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                      _cache[46] || (_cache[46] = _createElementVNode("label", { class: "block mb-1 font-semibold" }, "Especificar área o sector *", -1)),
                      _createVNode(_component_Field, {
                        name: "areaSectorOtro",
                        modelValue: _ctx.formData.areaSectorOtro,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.areaSectorOtro) = $event))
                      }, {
                        default: _withCtx(({ field, errors }) => [
                          _createVNode(_component_InputText, _mergeProps(field, {
                            type: "text",
                            placeholder: "Especifique el área o sector",
                            class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                          }), null, 16, ["class"]),
                          _createElementVNode("span", _hoisted_48, [
                            _createVNode(_component_ErrorMessage, { name: "areaSectorOtro" })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _cache[47] || (_cache[47] = _createElementVNode("label", { class: "block mb-1 font-semibold" }, "LinkedIn profesional, redes sociales o sitio web institucional (opcional)", -1)),
                  _createVNode(_component_Field, {
                    name: "redesSocialesLink",
                    modelValue: _ctx.formData.redesSocialesLink,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.redesSocialesLink) = $event))
                  }, {
                    default: _withCtx(({ field, errors }) => [
                      _createVNode(_component_InputText, _mergeProps(field, {
                        type: "text",
                        placeholder: "https://linkedin.com/in/... o enlace web",
                        class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                      }), null, 16, ["class"]),
                      _createElementVNode("span", _hoisted_51, [
                        _createVNode(_component_ErrorMessage, { name: "redesSocialesLink" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ])
            ]),
            _cache[68] || (_cache[68] = _createElementVNode("div", { class: "flex flex-wrap space-y-4 md:space-y-0 border border-gray-500 rounded-md shadow-lg mt-11 mb-6" }, [
              _createElementVNode("div", { class: "w-full text-gray-800 text-2xl text-center font-antonio-bold py-4" }, " ¿Cómo te enteraste del evento? * ")
            ], -1)),
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", {
                class: _normalizeClass(["w-full px-2", _ctx.mostrarMedioOtro ? 'md:w-6/12' : 'md:w-12/12'])
              }, [
                _cache[48] || (_cache[48] = _createElementVNode("label", { class: "block mb-1 font-semibold" }, "Seleccione una o más opciones *", -1)),
                _createVNode(_component_Field, {
                  name: "mediosSeleccionados",
                  modelValue: _ctx.formData.mediosSeleccionados,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.mediosSeleccionados) = $event))
                }, {
                  default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                    _createVNode(_component_MultiSelect, {
                      onBlur: handleBlur,
                      "onUpdate:modelValue": handleChange,
                      "model-value": value,
                      placeholder: "Seleccione cómo se enteró del evento",
                      class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined && value.length > 0, 'input-error': errors.length > 0 }]),
                      options: _ctx.medios,
                      optionLabel: "descripcion",
                      showToggleAll: false
                    }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                    _createElementVNode("span", _hoisted_53, [
                      _createVNode(_component_ErrorMessage, { name: "mediosSeleccionados" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ], 2),
              (_ctx.mostrarMedioOtro)
                ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                    _cache[49] || (_cache[49] = _createElementVNode("label", { class: "block mb-1 font-semibold" }, "Otro medio (especificar) *", -1)),
                    _createVNode(_component_Field, {
                      name: "medioOtro",
                      modelValue: _ctx.formData.medioOtro,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.medioOtro) = $event))
                    }, {
                      default: _withCtx(({ field, errors }) => [
                        _createVNode(_component_InputText, _mergeProps(field, {
                          type: "text",
                          placeholder: "Especifique cómo se enteró",
                          class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                        }), null, 16, ["class"]),
                        _createElementVNode("span", _hoisted_55, [
                          _createVNode(_component_ErrorMessage, { name: "medioOtro" })
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            (!_ctx.isEstudiante)
              ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                  _cache[53] || (_cache[53] = _createElementVNode("div", { class: "flex flex-wrap space-y-4 md:space-y-0 border border-gray-500 rounded-md shadow-lg mt-11 mb-6" }, [
                    _createElementVNode("div", { class: "w-full text-gray-800 text-2xl text-center font-antonio-bold py-4" }, " Sistema de Reuniones (Meeting) ")
                  ], -1)),
                  _createElementVNode("div", _hoisted_57, [
                    _cache[52] || (_cache[52] = _createElementVNode("div", { class: "text-gray-800 font-semibold mb-3 text-base sm:text-lg" }, " Crea tu contraseña para la plataforma meeting: esta te permitirá ser parte de espacios de vinculación y networking con otros asistentes y empresas del evento (obligatorio)* ", -1)),
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("div", _hoisted_59, [
                        _cache[50] || (_cache[50] = _createElementVNode("label", { class: "block mb-1 font-semibold" }, "Contraseña para meeting *", -1)),
                        _createVNode(_component_Field, {
                          name: "password",
                          modelValue: _ctx.formData.password,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.password) = $event))
                        }, {
                          default: _withCtx(({ field, errors }) => [
                            _createVNode(_component_InputText, _mergeProps(field, {
                              type: "password",
                              placeholder: "Contraseña de acceso",
                              class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                            }), null, 16, ["class"]),
                            _createElementVNode("span", _hoisted_60, [
                              _createVNode(_component_ErrorMessage, { name: "password" })
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_61, [
                        _cache[51] || (_cache[51] = _createElementVNode("label", { class: "block mb-1 font-semibold" }, "Confirmar contraseña *", -1)),
                        _createVNode(_component_Field, {
                          name: "confirmPassword",
                          modelValue: _ctx.formData.confirmPassword,
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.confirmPassword) = $event))
                        }, {
                          default: _withCtx(({ field, errors }) => [
                            _createVNode(_component_InputText, _mergeProps(field, {
                              type: "password",
                              placeholder: "Confirmá tu contraseña",
                              class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                            }), null, 16, ["class"]),
                            _createElementVNode("span", _hoisted_62, [
                              _createVNode(_component_ErrorMessage, { name: "confirmPassword" })
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _cache[69] || (_cache[69] = _createElementVNode("div", { class: "flex flex-wrap space-y-4 md:space-y-0 border border-gray-500 rounded-md shadow-lg mt-11 mb-6" }, [
              _createElementVNode("div", { class: "w-full text-gray-800 text-2xl text-center font-antonio-bold py-4" }, " Política de Privacidad y Consentimiento ")
            ], -1)),
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _cache[55] || (_cache[55] = _createElementVNode("span", { class: "text-gray-800 font-semibold text-base" }, "Términos y condiciones del evento", -1)),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.mostrarModalPoliticas = true)),
                  class: "inline-flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-md shadow-sm transition text-sm cursor-pointer"
                }, _cache[54] || (_cache[54] = [
                  _createElementVNode("i", { class: "pi pi-file-o" }, null, -1),
                  _createTextVNode(" Ver políticas ")
                ]))
              ]),
              _createElementVNode("div", null, [
                _cache[57] || (_cache[57] = _createElementVNode("label", { class: "block font-bold text-gray-800 mb-2" }, " Autorización de uso (selección obligatoria) * ", -1)),
                _createVNode(_component_Field, {
                  name: "autorizoImagen",
                  modelValue: _ctx.formData.autorizoImagen,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.autorizoImagen) = $event))
                }, {
                  default: _withCtx(({ handleChange, value, errors }) => [
                    _createElementVNode("div", _hoisted_65, [
                      _createVNode(_component_Checkbox, {
                        "model-value": value,
                        binary: true,
                        inputId: "autorizoImagen",
                        "onUpdate:modelValue": handleChange,
                        invalid: errors.length > 0,
                        class: "mt-0.5"
                      }, null, 8, ["model-value", "onUpdate:modelValue", "invalid"]),
                      _cache[56] || (_cache[56] = _createElementVNode("label", {
                        for: "autorizoImagen",
                        class: "cursor-pointer text-sm text-gray-800 leading-snug"
                      }, " Autorizo el uso de mi imagen para registros fotográficos y audiovisuales de Córdoba Tech Week y Córdoba Cluster. ", -1))
                    ]),
                    _createElementVNode("span", _hoisted_66, [
                      _createVNode(_component_ErrorMessage, { name: "autorizoImagen" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_67, [
                _cache[59] || (_cache[59] = _createElementVNode("label", { class: "block font-bold text-gray-800 mb-2" }, " Autorización de política (selección obligatoria) * ", -1)),
                _createVNode(_component_Field, {
                  name: "autorizoPolitica",
                  modelValue: _ctx.formData.autorizoPolitica,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formData.autorizoPolitica) = $event))
                }, {
                  default: _withCtx(({ handleChange, value, errors }) => [
                    _createElementVNode("div", _hoisted_68, [
                      _createVNode(_component_Checkbox, {
                        "model-value": value,
                        binary: true,
                        inputId: "autorizoPolitica",
                        "onUpdate:modelValue": handleChange,
                        invalid: errors.length > 0,
                        class: "mt-0.5"
                      }, null, 8, ["model-value", "onUpdate:modelValue", "invalid"]),
                      _cache[58] || (_cache[58] = _createElementVNode("label", {
                        for: "autorizoPolitica",
                        class: "cursor-pointer text-sm text-gray-800 leading-snug"
                      }, " Acepto la política de protección de datos personales y consiento el uso de la información brindada para fines exclusivamente organizativos y de vinculación de Córdoba Tech Week y Córdoba Cluster. ", -1))
                    ]),
                    _createElementVNode("span", _hoisted_69, [
                      _createVNode(_component_ErrorMessage, { name: "autorizoPolitica" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_70, [
                _cache[62] || (_cache[62] = _createElementVNode("label", { class: "block font-bold text-gray-800 mb-2" }, " 📩 Comunicaciones (selección obligatoria) * ", -1)),
                _createVNode(_component_Field, {
                  name: "comunicaciones",
                  modelValue: _ctx.formData.comunicaciones,
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.formData.comunicaciones) = $event))
                }, {
                  default: _withCtx(({ handleChange, errors }) => [
                    _createElementVNode("div", {
                      class: _normalizeClass(["space-y-3", { 'text-red-600': errors.length > 0 }])
                    }, [
                      _createElementVNode("label", _hoisted_71, [
                        _createVNode(_component_RadioButton, {
                          modelValue: _ctx.formData.comunicaciones,
                          "onUpdate:modelValue": [
                            _cache[25] || (_cache[25] = ($event: any) => ((_ctx.formData.comunicaciones) = $event)),
                            handleChange
                          ],
                          name: "comunicaciones",
                          value: "Si",
                          class: "mt-1",
                          invalid: errors.length > 0
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "invalid"]),
                        _cache[60] || (_cache[60] = _createElementVNode("span", { class: "text-sm text-gray-800 leading-snug" }, " Sí, quiero recibir novedades, actividades y contenidos de Córdoba Tech Week y Córdoba Cluster. Esto incluye confirmaciones, actualizaciones del cronograma, encuestas de satisfacción y futuras actividades vinculadas al ecosistema Córdoba Tech Week. Podés darte de baja en cualquier momento ", -1))
                      ]),
                      _createElementVNode("label", _hoisted_72, [
                        _createVNode(_component_RadioButton, {
                          modelValue: _ctx.formData.comunicaciones,
                          "onUpdate:modelValue": [
                            _cache[26] || (_cache[26] = ($event: any) => ((_ctx.formData.comunicaciones) = $event)),
                            handleChange
                          ],
                          name: "comunicaciones",
                          value: "No",
                          class: "mt-1",
                          invalid: errors.length > 0
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "invalid"]),
                        _cache[61] || (_cache[61] = _createElementVNode("span", { class: "text-sm text-gray-800 leading-snug" }, " No quiero recibir novedades acerca el evento ", -1))
                      ])
                    ], 2),
                    _createElementVNode("span", _hoisted_73, [
                      _createVNode(_component_ErrorMessage, { name: "comunicaciones" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _cache[70] || (_cache[70] = _createElementVNode("div", { class: "flex flex-wrap space-y-4 md:space-y-0 mt-6 py-4 border border-gray-500 rounded-md shadow-lg" }, [
              _createElementVNode("div", { class: "w-full text-center font-semibold" }, " Para más información, podés escribirnos a "),
              _createElementVNode("div", { class: "w-full text-center" }, [
                _createElementVNode("a", {
                  href: "mailto:inscripciones@cordobacluster.com",
                  class: "text-blue-600 font-semibold underline"
                }, "inscripciones@cordobacluster.com")
              ])
            ], -1)),
            _cache[71] || (_cache[71] = _createElementVNode("div", { class: "flex flex-wrap space-y-4 md:space-y-0 mt-6 py-4 border border-gray-500 rounded-md shadow-lg" }, [
              _createElementVNode("div", { class: "w-full text-center font-semibold" }, " Te vamos a enviar un correo con más información del evento "),
              _createElementVNode("div", { class: "w-full text-center font-semibold" }, " Por favor verificá el mismo para completar tu acreditación ")
            ], -1)),
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("button", {
                type: "submit",
                class: "mt-4 px-6 py-3 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border-2 rounded text-lg transition duration-200 cursor-pointer",
                disabled: _ctx.isSubmitting
              }, [
                _withDirectives(_createElementVNode("i", _hoisted_76, null, 512), [
                  [_vShow, _ctx.isSubmitting]
                ]),
                _withDirectives(_createElementVNode("i", _hoisted_77, null, 512), [
                  [_vShow, !_ctx.isSubmitting]
                ]),
                _cache[63] || (_cache[63] = _createTextVNode("REGISTRARME "))
              ], 8, _hoisted_75)
            ])
          ]),
          _createVNode(_component_BlockUI, {
            blocked: _ctx.isSubmitting,
            fullScreen: ""
          }, null, 8, ["blocked"])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema", "onInvalidSubmit"]),
      _createVNode(_component_Dialog, {
        visible: _ctx.mostrarModalPoliticas,
        "onUpdate:visible": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.mostrarModalPoliticas) = $event)),
        modal: "",
        header: "Política de Privacidad y Consentimiento",
        style: { width: '90vw', maxWidth: '720px' }
      }, {
        footer: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.mostrarModalPoliticas = false)),
            class: "px-4 py-2 bg-gray-800 hover:bg-black text-white rounded-md text-sm cursor-pointer"
          }, " Entendido ")
        ]),
        default: _withCtx(() => [
          _cache[72] || (_cache[72] = _createElementVNode("div", { class: "space-y-4 text-sm text-gray-700 leading-relaxed max-h-[70vh] overflow-y-auto pr-2" }, [
            _createElementVNode("h3", { class: "font-bold text-base text-gray-900 border-b pb-2" }, "Leer política de Privacidad y Consentimiento"),
            _createElementVNode("div", null, [
              _createElementVNode("h4", { class: "font-bold text-gray-900 mb-1" }, "Responsable del tratamiento"),
              _createElementVNode("p", null, [
                _createTextVNode(" Los datos personales recabados a través del presente formulario serán tratados por "),
                _createElementVNode("strong", null, "Cluster Tecnológico Córdoba - Asociación Civil"),
                _createTextVNode(", CUIT 30-70782266-6, con domicilio en Avenida La Voz Del Interior 8851, piso 6, barrio Alta Córdoba, Córdoba Capital, en su carácter de organizador de Córdoba Tech Week 2026. ")
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("h4", { class: "font-bold text-gray-900 mb-1" }, "Finalidad del tratamiento de datos personales"),
              _createElementVNode("p", null, "Los datos proporcionados serán utilizados exclusivamente para:"),
              _createElementVNode("ul", { class: "list-disc list-inside mt-1 space-y-1" }, [
                _createElementVNode("li", null, "Gestionar la inscripción y acreditación a Córdoba Tech Week 2026;"),
                _createElementVNode("li", null, "Organizar y coordinar la logística del evento y sus subeventos (Zona VIP, Cóctel, Ronda de Negocios, entre otros);"),
                _createElementVNode("li", null, "Enviar confirmaciones, actualizaciones de cronograma y comunicaciones operativas vinculadas a la participación;"),
                _createElementVNode("li", null, "En caso de haber prestado el consentimiento correspondiente, enviar novedades del ecosistema Córdoba Tech Week y compartir datos de contacto con empresas/instituciones aliadas.")
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("h4", { class: "font-bold text-gray-900 mb-1" }, "Plazo de conservación"),
              _createElementVNode("p", null, " Los datos personales serán conservados durante el tiempo necesario para cumplir con las finalidades indicadas en la presente política de privacidad. En ningún caso los datos personales serán conservados ni utilizados para finalidades distintas de aquellas para las cuales el titular prestó su consentimiento. ")
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("h4", { class: "font-bold text-gray-900 mb-1" }, "Compartir datos con empresas e instituciones (debes seleccionar una opción)"),
              _createElementVNode("p", null, " Al inscribirme, doy mi consentimiento para que Córdoba Tech Week / Córdoba Cluster comparta mis datos de contacto con empresas, instituciones y organizaciones participantes o aliadas del evento. "),
              _createElementVNode("p", { class: "mt-1" }, " El participante reconoce y acepta que sus datos serán comunicados a terceros, quienes serán responsables del tratamiento que realicen de dichos datos, sin que Córdoba Tech Week / Córdoba Cluster asuma responsabilidad por el uso, tratamiento o finalidad que dichos terceros puedan darles, una vez efectuada la comunicación. ")
            ]),
            _createElementVNode("div", { class: "space-y-3 pt-3 border-t border-gray-200 text-xs text-gray-600" }, [
              _createElementVNode("h4", { class: "font-bold text-gray-800 text-sm" }, "A tener en cuenta:"),
              _createElementVNode("p", null, [
                _createElementVNode("strong", null, "Uso de imagen:"),
                _createTextVNode(" Córdoba Tech Week 2026 es un evento masivo y abierto al público asistente, en el marco del cual se realizarán registros fotográficos y audiovisuales generales del evento (tomas de público, paneles, stands, actividades, etc.). Dicha captación se encuentra alcanzada por la excepción prevista en el art. 53, inc. c) del Código Civil y Comercial de la Nación (captación de imagen realizada en el marco de acontecimientos públicos o de interés general en los que participa el titular), por lo que no requiere consentimiento individual y podrá ser utilizada por Córdoba Tech Week y Córdoba Cluster con fines de cobertura, difusión institucional y promocional del evento (redes sociales, sitio web, publicidad y comunicaciones de futuras ediciones), en medios oficiales. Distinto es el caso de un uso individualizado o destacado de la imagen de una persona en particular (por ejemplo, entrevistas, testimoniales, piezas publicitarias centradas en un asistente identificado), para lo cual sí se solicitará el consentimiento específico de la persona en el momento correspondiente. ")
              ]),
              _createElementVNode("p", null, [
                _createElementVNode("strong", null, "Derechos de los titulares:"),
                _createTextVNode(" El titular de los datos personales tiene la facultad de ejercer el derecho de acceso a los mismos en términos de la Ley 25.326. Asimismo, podrá solicitar la rectificación, actualización o supresión de sus datos, y revocar en cualquier momento el consentimiento prestado, escribiendo a "),
                _createElementVNode("a", {
                  href: "mailto:info@cordobacluster.com",
                  class: "text-blue-600 underline"
                }, "info@cordobacluster.com"),
                _createTextVNode(", sin efecto retroactivo sobre los tratamientos ya realizados de forma lícita con anterioridad a la revocación. ")
              ]),
              _createElementVNode("p", null, " En particular, y conforme a lo ya señalado, la revocación no habilita a exigir la eliminación de material de cobertura general del evento (fotos, videos institucionales, piezas de difusión masiva), dado que dicha captación no depende del consentimiento individual sino de la excepción legal aplicable. ")
            ])
          ], -1))
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ], 64))
}